
import { format, addDays } from "date-fns";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import CartProductCard from "~/components/common/CartDrawer/CartProductCard";
import CartRelatedProducts from "~/components/common/CartRelatedProducts";
import googleAnalyticsEvents from "~/mixins/googleAnalyticsEvents";
import facebookPixelEvents from "~/mixins/facebookPixelEvents";
import useEvents from "~/mixins/useEvents";

export default {
  name: "CartDrawer",
  components: {
    CartProductCard,
    CartRelatedProducts,
  },
  mixins: [googleAnalyticsEvents, facebookPixelEvents, useEvents],
  data() {
    return {
      relatedProductsFullList: [],
      shouldRenderRelated: false,
    };
  },
  computed: {
    ...mapState({
      isOpenCartDrawer: (state) => state.general.isOpenCartDrawer,
    }),
    ...mapGetters({
      cartInfo: "cart/getCartInfo",
      cartItemsCount: "cart/getCartItemsCount",
      cartId: "getCartId",
      getSettings: "general/getSettings",
      getSystemDateFormat: "general/getSystemDateFormat",
      hasOnlyDigitalItemsInCart: "cart/getHasOnlyDigitalItemsInCart",
      removingIdsLoading: "cart/getRemovingIdsLoading",
    }),
    estimatedDeliveryDate() {
      return format(
        new Date(this.cartInfo.ship_date || ""),
        this.getSystemDateFormat
      );
    },
    productSkusInCart() {
      if (!this.cartInfo || !this.cartInfo.items) {
        return [];
      }
      return this.cartInfo.items.map((item) => item.configuration_id);
    },
    relatedProducts() {
      if (
        !Array.isArray(this.relatedProductsFullList) ||
        this.cartItemsCount === 0
      ) {
        return [];
      }
      return this.relatedProductsFullList.filter((item) => {
        const productSKU =
          item?.variant_plp_image?.sku ||
          item?.default_config?.configuration_id ||
          item?.default_sku;

        return !this.productSkusInCart.includes(productSKU);
      });
    },
  },
  watch: {
    isOpenCartDrawer: {
      handler(val) {
        if (!process.client) return;

        if (val) {
          document.body.style.overflow = "hidden";
          this.gaViewCartEvent(this.cartInfo);
          this.fbViewCartEvent(this.cartInfo);
          if (this.cartItemsCount > 0) {
            this.loadRelatedProducts();
          }
        } else {
          document.body.style.overflow = "";
          this.shouldRenderRelated = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations({
      toggleCartDrawer: "general/TOGGLE_CART_DRAWER",
      closeCartDrawer: "general/CLOSE_CART_DRAWER",
    }),
    ...mapActions({
      updateCartItem: "cart/updateCartItem",
      removeCartItem: "cart/removeCartItem",
      setCartInfo: "cart/setCartInfo",
    }),
    async removeCartProduct(event, item, index) {
      await this.removeCartItem(event);
      this.gaRemoveFromCartEvent(item, index);
      this.removeFromCartEvent({
        product_id: item.product_id,
        configuration_id: item.configuration_id,
        collection_id: item.collections?.[0]?.id || "",
        product_sku: item.vendor_model,
        product_price: item.base_cost,
      });
      await this.loadRelatedProducts();
    },
    closeCartDrawerAndSendStatistic() {
      this.closeCartDrawer();
      this.gaBeginCheckoutEvent(this.cartInfo);
      this.fbBeginCheckoutEvent(this.cartInfo?.items);
      this.fbInitiateCheckoutEvent(this.cartInfo);
      this.$router.push(this.localePath(`/checkout/${this.cartId}`));
    },
    async loadRelatedProducts() {
      try {
        const { data } = await this.$api.cart.getCartRelatedProducts(
          this.cartId
        );
        this.relatedProductsFullList = data.data || [];
        this.shouldRenderRelated = true;
      } catch (error) {
        this.relatedProductsFullList = [];
      }
    },
  },
};
